import axios from "axios";

const isLocal = window.location.host === "localhost:8080";

const HOST = isLocal
  ? `${process.env.VITE_APP_BACKEND_DEV}/api/v1`
  : `${window.location.protocol}//${window.location.hostname}/api/v1/`;

const headers = {
  Accept: "application/json",
};

if (isLocal || localStorage.getItem("token")) {
  console.log("insideBearer");
  headers[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
}

const AuthBackend = axios.create({
  baseURL: HOST,
  withCredentials: true,
  headers,
});

let env = import.meta.env;
let centralDomain = `https://${env.VITE_CENTRAL_DOMAINS}`;
const CentralBackend = axios.create({
  baseURL: `${centralDomain}/api/v1`,
  withCredentials: true,
  headers,
});

export { AuthBackend, CentralBackend };
